import React from "react";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../siteConfig";

export default function DemoPage() {
  return (
    <div className="app page-grid">
      <Helmet>
        <title>Sample Technical SEO & Visibility Report | OptiSiteSEO Demo</title>
        <meta
          name="description"
          content="Preview a sample OptiSiteSEO technical SEO and visibility report. See how we present discoverability issues, impact, and clear next steps."
        />
        <link rel="canonical" href={canonicalUrl("/demo")} />
      </Helmet>

      <section className="card section page-hero">
        <p className="eyebrow">Sample report</p>
        <h1>Preview the technical SEO and visibility report</h1>
        <p className="subtext">
          This demo shows the structure of the report your team will see. For a live technical SEO and visibility report, run a scan on your domain.
        </p>
        <div className="cta-row">
          <a className="primary" href="/app/index.html">
            Run Free SEO Scan
          </a>
          <a className="secondary" href="/demo_report.json" target="_blank" rel="noreferrer">
            View demo data
          </a>
        </div>
      </section>
    </div>
  );
}
